import { useState } from "react";
import { Typography, Box, Link, Switch, Grid } from "@mui/material";
import { LoadingError, LoadingPaper } from "../../LoadingComponents";
import { renderEUDateTime } from "../../../utils/utils";
import { useGetOrganizationById, useGetUserById } from "../useHandlingQueries";
import {
  EditableBoolInput,
  EditableInputDisplay,
} from "../../EditableComponents";
import UploadFileButton from "../../UploadFileButton/UploadFileButton";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";

function ViewOrganization({ editMode, updateEditState, org_id }) {
  // === web service queries/mutations ===
  const orgQuery = useGetOrganizationById(org_id);
  const [file, setFile] = useState(null);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  return (
    <>
      {orgQuery.isLoading ? (
        <LoadingPaper />
      ) : orgQuery.isError ? (
        <LoadingError error={orgQuery.error} />
      ) : (
        orgQuery.data !== undefined && (
          <Box
            sx={{
              display: "grid",
              margin: "auto",
              gridTemplateColumns: "1fr 1fr",
              width: "100%",
            }}
          >
            <Box sx={{ margin: "10px" }}>
              <EditableInputDisplay
                id={"email"}
                label={"Email:"}
                initialValue={orgQuery.data.email}
                setEditMode={editMode}
                inputMode={"text"}
                setParentValue={updateEditState}
              />
              <EditableInputDisplay
                id={"phone"}
                label={"Cellulare:"}
                initialValue={orgQuery.data.phone}
                setEditMode={editMode}
                inputMode={"text"}
                setParentValue={updateEditState}
              />
              <EditableInputDisplay
                id={"piva"}
                label={"P. IVA:"}
                initialValue={orgQuery.data.piva}
                setEditMode={editMode}
                inputMode={"text"}
                setParentValue={updateEditState}
              />
              <Typography>
                <strong>Org. ID:</strong> {org_id}
              </Typography>

              <Typography>
                <strong>Data creazione:</strong>{" "}
                {renderEUDateTime(orgQuery.data.date_of_creation)}
              </Typography>
              <EditableInputDisplay
                setEditMode={editMode}
                id={"include_h3k_logo"}
                label="Includi logo Health3000"
                initialValue={orgQuery.data.include_h3k_logo}
                inputMode={"bool"}
                setParentValue={updateEditState}
              />
              <Grid container sx={{ alignItems: "center" }}>
                <Grid item xs={6}>
                  <Typography id={"logo_uploaded"}>
                    <strong>Logo caricato</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Grid container alignItems="center" spacing={1}>
                    <Grid item xs>
                      {orgQuery.data.logo == null ||
                      orgQuery.data.logo == "null" ||
                      (orgQuery.data.logo != null &&
                        orgQuery.data.logo.length == 0) ? (
                        <CloseIcon color="error" />
                      ) : (
                        <DoneIcon color="success" />
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>

            <Box sx={{ margin: "10px" }}>
              <EditableInputDisplay
                id={"address"}
                label={"Indirizzo:"}
                initialValue={orgQuery.data.address}
                setEditMode={editMode}
                inputMode={"text"}
                setParentValue={updateEditState}
              />
              <EditableInputDisplay
                id={"city"}
                label={"Città:"}
                initialValue={orgQuery.data.city}
                setEditMode={editMode}
                inputMode={"text"}
                setParentValue={updateEditState}
              />
              <EditableInputDisplay
                id={"province"}
                label={"Provincia:"}
                initialValue={orgQuery.data.province}
                setEditMode={editMode}
                inputMode={"text"}
                setParentValue={updateEditState}
              />
              <EditableInputDisplay
                id={"cap"}
                label={"CAP:"}
                initialValue={orgQuery.data.cap}
                setEditMode={editMode}
                inputMode={"text"}
                setParentValue={updateEditState}
              />
              <EditableInputDisplay
                setEditMode={editMode}
                id={"client_logo_pos"}
                label="Posizione Logo Org."
                initialValue={orgQuery.data.client_logo_pos}
                inputMode={"select"}
                setParentValue={updateEditState}
                selectQueryKey={null}
                selectType={"position"}
              />
            </Box>
          </Box>
        )
      )}
    </>
  );
}

export default ViewOrganization;
